// JOBE-0167.5: DecayTabBody — memories near the decay threshold.
//
// Data source: GET /api/memory?near_decay=true (the near_decay filter does
// not exist on JOBE-0076.6.4's List endpoint yet; v1 ships the acceptable
// fallback — empty state when no fixture, no real wire call. A follow-up
// spec adds the filter to JOBE-0076.6.4's List endpoint).
//
// Fixture: memory.mock.conflicts (extended with decay metadata in this subtask).

import { useFlagStore } from '../../lib/useFlagStore.js';
import { flaggedFetch } from '../../lib/flags.js';
import { DecayRow } from './DecayRow.jsx';

export function DecayTabBody() {
  const overrides = useFlagStore((s) => s.overrides);
  // TODO(JOBE-0167-followup): wire near-decay filter on JOBE-0076.6.4 List endpoint.
  const fx = flaggedFetch('memory.mock.conflicts', overrides);
  const rows = Array.isArray(fx) ? fx : (fx?.memories || fx?.rows || []);
  if (rows.length === 0) {
    return (
      <div className="decay-body" data-testid="decay-body">
        <div data-testid="decay-empty">No memories are near the decay threshold.</div>
      </div>
    );
  }
  return (
    <div className="decay-body" data-testid="decay-body">
      <ul className="decay-body__list" data-testid="decay-list">
        {rows.map((m, i) => (
          <DecayRow key={m.urn || i} memory={m} />
        ))}
      </ul>
    </div>
  );
}

export default DecayTabBody;
